module.exports = __webpack_public_path__ + "img/48_29.e6041616.png";